<template>
    <div>
        <informacion class="mx-auto mt-2"
                     titulo="Guarda"
                     :texto="text"
                     @click="dialog = true">
        </informacion>
        <v-dialog v-model="dialog"
                  max-width="650px"
                  max-heigh="500px"
                  persistent>
            <depositoPuestoDialogo :item="item"
                                   @closeDlg="dialog = false"
                                   @change="change($event)" />
        </v-dialog>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import depositoPuestoDialogo from '@/components/Tools/DepositoPuesto/DepositoPuestoDialogo';
    import informacion from '@/components/Tools/Informacion';

    export default {
        name: 'depositoPuesto',

        // item: deposito, puestoId
        props: ['item', 'disabled'],

        data: () => ({
            dialog: false,
            isLoading: false,
            select: null,
            search: null,
            depositoPuesto: {}
        }),

        methods: {
            change(item) {
                this.$emit('change', item);
            },

        },

        computed: {
            ...mapState('deposito', ['items']),

            text() {
                if (!this.item)
                    return '---';

                const deposito = this.item.deposito && this.item.deposito.nombre
                    ? this.item.deposito
                    : null;

                const depositoId = this.item.depositoId ||
                    (deposito ? deposito.id : null) ||
                    (this.item.deposito ? this.item.deposito.id : null);

                const depositoFromList = deposito ||
                    (depositoId ? this.items.find(x => x.id == depositoId) : null);

                const nombre = depositoFromList && depositoFromList.nombre
                    ? depositoFromList.nombre
                    : '';

                if (!nombre && !this.item.puestoId)
                    return '---';

                return nombre + ((this.item.puestoId != null) ? (' / ' + this.item.puestoId) : '');
            }
        },

        components: {
            depositoPuestoDialogo,
            informacion,
        }
    };
</script>
